import { Pipe, PipeTransform } from '@angular/core';
import twemoji from 'twemoji';

@Pipe({ name: 'twemoji' })
export class TwemojiPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return value;
    return twemoji.parse(value, {
      folder: 'svg',
      ext: '.svg',
      size: '72'
    });
  }
}